import { render } from "./CreCenterView.vue?vue&type=template&id=38ef4744&scoped=true"
import script from "./CreCenterView.vue?vue&type=script&lang=js"
export * from "./CreCenterView.vue?vue&type=script&lang=js"

import "./CreCenterView.vue?vue&type=style&index=0&id=38ef4744&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ef4744"]])

export default __exports__